/**
 * @typedef {object} options
 *  @property {string} [element=#wb-barba-transition] HTML selector
 *  @property {number|string} [duration=0.75] Animation duration in seconds or CSS Var
 *  @property {bool} [spinner=true] Show a spinner when pages are slower to load
 *  @property {bool} [useVars=true] Set to true in order to use CSS Vars for transition settings
 */
